// Material UI
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";

// Data for the drop downs
import status from "../../../../Utilities/Status";
import states from "../../../../Utilities/States";
import { creditCards } from "../../../../Utilities/creditCards";
import brands from "../../../../Utilities/Brands";

const generateForm = (
  phone,
  setPhone,
  email,
  setEmail,
  firstName,
  setFirstName,
  lastName,
  setLastName,
  firstSix,
  setFirstSix,
  lastFour,
  setLastFour,
  cardTypeId,
  setCreditCardID,
  bId,
  setbId,
  city,
  setCity,
  zip,
  setZip,
  cId,
  setCid,
  oId,
  setOid,
  state,
  setState,
  orderStatus,
  setOrderStatus,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  membershipEmail,
  setMembershipEmail,
  scn,
  setScn,
  sca,
  setSca,
  ipAddress,
  setIpAddress,
  includeInactiveCustomers,
  setIncludeInactiveCustomers
) => {
  const formLabels = [
    {
      Label: "Phone Number",
      Element: "TextField",
      Value: phone,
      Setter: setPhone,
    },
    {
      Label: "Email",
      Element: "TextField",
      Value: email,
      Setter: setEmail,
    },
    {
      Label: "First Name",
      Element: "TextField",
      Value: firstName,
      Setter: setFirstName,
    },
    {
      Label: "Last Name",
      Element: "TextField",
      Value: lastName,
      Setter: setLastName,
    },
    {
      Label: "Credit Card (First 6#)",
      Element: "TextField",
      Value: firstSix,
      Setter: setFirstSix,
    },
    {
      Label: "Credit Card (Last 4#)",
      Element: "TextField",
      Value: lastFour,
      Setter: setLastFour,
    },
    {
      Label: "Credit Card ID",
      Element: "FormControl",
      Value: cardTypeId,
      Setter: setCreditCardID,
      Data: (
        <>
          <option value="" />
          {creditCards.map((card, idx) => {
            let cardID = "";
            switch (card) {
              case "Visa":
                cardID = 1;
                break;
              case "Mastercard":
                cardID = 2;
                break;
              case "American Express":
                cardID = 3;
                break;
              case "Discover":
                cardID = 4;
                break;
              case "Google Pay - Unknown":
                cardID = 9;
                break;
              case "Google Pay - Visa":
                cardID = 10;
                break;
              case "Google Pay - Mastercard":
                cardID = 11;
                break;
              case "Google Pay - Amex":
                cardID = 12;
                break;
              default:
                return null;
            }
            return (
              <option key={idx} value={cardID}>
                {card}
              </option>
            );
          })}
        </>
      ),
    },
    {
      Label: "City",
      Element: "TextField",
      Value: city,
      Setter: setCity,
    },
    {
      Label: "Zip",
      Element: "TextField",
      Value: zip,
      Setter: setZip,
    },
    {
      Label: "Customer ID",
      Element: "TextField",
      Value: cId,
      Setter: setCid,
    },
    {
      Label: "Brand ID",
      Element: "FormControl",
      Value: bId,
      Setter: setbId,
      Data: <>
      <option value="" />
        {brands.map((card, idx) => {
          let brandId = "";
          switch (card.brand) {
            case "KLS":
              brandId = card._id;
              break;
            case "SF":
              brandId = card._id;
              break;
            case "PDC":
              brandId = card._id;
              break;
            case "PIS":
              brandId = card._id;
              break;
            case "SPR":
              brandId = card._id;
              break;
            case "PRR":
              brandId = card._id;
              break;
            case "QPR":
              brandId = card._id;
              break;
            case "PF":
              brandId = card._id;
              break;
            default:
              return null;
          }
          return (
            <option key={idx} value={brandId}>
              {card.brand}
            </option>
          );
        })}
    </>
    },
    {
      Label: "Order ID",
      Element: "TextField",
      Value: oId,
      Setter: setOid,
    },

    {
      Label: "State",
      Element: "FormControl",
      Value: state,
      Setter: setState,
      Data: (
        <>
          <option value="" />
          {states.map((state, idx) => (  
            <option key={idx} value={state.id}>
              {state.name}
            </option>            
          ))}
        </>
      ),
    },
    {
      Label: "Order Status",
      Element: "FormControl",
      Value: orderStatus,
      Setter: setOrderStatus,
      Data: (
        <>
          <option value="" />
          {status.map((status, idx) => (
            <option key={idx} value={status.id}>
              {status.status}
            </option>
          ))}
        </>
      ),
    },
    {
      Label: "Start Date",
      Element: "TextField",
      Type: "date",
      Value: startDate,
      Setter: setStartDate,
    },
    {
      Label: "End Date",
      Element: "TextField",
      Type: "date",
      Value: endDate,
      Setter: setEndDate,
    },
    {
      Label: "Membership Email",
      Element: "TextField",
      Value: membershipEmail,
      Setter: setMembershipEmail,
    },
    {
      Label: "SCN",
      Element: "TextField",
      Value: scn,
      Setter: setScn,
    },
    {
      Label: "SCA",
      Element: "TextField",
      Value: sca,
      Setter: setSca,
    },
    {
      Label: "IpAddress",
      Element: "TextField",
      Value: ipAddress,
      Setter: setIpAddress,
    },
    {
      Label: "Include Inactive Customers",
      Element: "Checkbox",
      Value: includeInactiveCustomers,
      Setter: setIncludeInactiveCustomers,
    },
  ];

  return formLabels.map(
    ({ Label, Element, Type, Data, Value, Setter }, idx) => {
      switch (Element) {
        case "TextField":
          return (
            <TextField
              id="outlined-full-width"
              className="input-el"
              label={Label}
              type={Type}
              style={{ margin: 8, width: "14rem" }}
              fullWidth={false}
              margin="normal"
              InputLabelProps={{ shrink: true }}
              variant="outlined"
              value={Value}
              onChange={(e) => Setter(e.target.value)}
            />
          );
        case "FormControl":
          return (
            <FormControl
              variant="outlined"
              style={{ margin: 8, width: "14rem" }}
              value={Value}
              onChange={(e) => Setter(e.target.value)}
            >
              <InputLabel htmlFor="outlined-age-native-simple">
                {Label}
              </InputLabel>
              <Select
                native={true}
                label={Label}
                inputProps={{
                  name: `${Label.toLowerCase()}`,
                  id: `outlined-${Label.toLowerCase()}-native-simple`,
                }}
              >
                {Data}
              </Select>
            </FormControl>
          );
        case "Checkbox":
          return (
            <FormGroup >
              <FormControlLabel
                control={<Checkbox checked={Value} onChange={(e) => Setter(e.target.checked)} />}
                label={Label}
                style={{ margin: 5, width: "15rem", color: '#accfe6' }}
              />
            </FormGroup>
          );
        default:
          return null;
      }
    }
  );
};

export default generateForm;
